// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AppointmentInsuranceVerificationResponse } from './appointment-insurance-verification-response';

// @ts-ignore
import { EmployeeNameResponse } from './employee-name-response';

// @ts-ignore
import { EncounterTemplateResponse } from './encounter-template-response';

// @ts-ignore
import { PatientNameResponse } from './patient-name-response';

// @ts-ignore
import { PhoneNumbersResponse } from './phone-numbers-response';

// @ts-ignore
import { PracticeLocationSummaryResponse } from './practice-location-summary-response';

// @ts-ignore
import { ProviderResponse } from './provider-response';

// @ts-ignore
import { RecurringDefinitionResponse } from './recurring-definition-response';

// @ts-ignore
import { ScheduleItemResponse } from './schedule-item-response';

// @ts-ignore
import { SecurityRoleResponse } from './security-role-response';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.AppointmentResponse */
/* istanbul ignore next */
@GandalfModel
export class AppointmentResponse extends ScheduleItemResponse {

	@GandalfProperty({ designType: Date })
	actualEndDate!: Date | null;

	@GandalfProperty({ designType: Date })
	actualStartDate!: Date | null;

	@GandalfProperty({ designType: AppointmentInsuranceVerificationResponse })
	appointmentInsuranceVerificationResponse!: AppointmentInsuranceVerificationResponse | null;

	@GandalfProperty({ designType: Boolean })
	confirmationRequired!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	confirmed!: boolean | null;

	@GandalfProperty({ designType: Date })
	createdOn!: Date | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	displayColor!: number | null;

	@GandalfProperty({ designType: EmployeeNameResponse })
	employee!: EmployeeNameResponse | null;

	@GandalfConstantDecorator(constants.EncounterApprovalStatus)
	@GandalfProperty({ designType: constants.EncounterApprovalStatus })
	encounterApprovalStatus!: constants.EncounterApprovalStatus | null;

	@GandalfProperty({ designType: Number })
	encounterId!: number | null;

	@GandalfConstantDecorator(constants.EncounterStatus)
	@GandalfProperty({ designType: constants.EncounterStatus })
	encounterStatus!: constants.EncounterStatus | null;

	@GandalfProperty({ designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Number })
	groupingPersonId!: number | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfConstantDecorator(constants.InterviewStatus)
	@GandalfProperty({ designType: constants.InterviewStatus })
	interviewStatus!: constants.InterviewStatus | null;

	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfProperty({ designType: PracticeLocationSummaryResponse })
	locationSummary!: PracticeLocationSummaryResponse | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	patientDob!: Date | null;

	@GandalfProperty({ designType: String })
	patientEmail!: string | null;

	@GandalfConstantDecorator(constants.EstablishedStatus)
	@GandalfProperty({ designType: constants.EstablishedStatus })
	patientEstablishedStatus!: constants.EstablishedStatus | null;

	@GandalfConstantDecorator(constants.Gender)
	@GandalfProperty({ designType: constants.Gender })
	patientGender!: constants.Gender | null;

	@GandalfProperty({ designType: Number })
	patientId!: number | null;

	@GandalfProperty({ designType: PatientNameResponse })
	patientName!: PatientNameResponse | null;

	@GandalfProperty({ designType: Boolean })
	patientPHRLogin!: boolean | null;

	@GandalfProperty({ designType: Number })
	patientPersonId!: number | null;

	@GandalfProperty({ designType: PhoneNumbersResponse })
	patientPhoneNumbers!: PhoneNumbersResponse | null;

	@GandalfProperty({ designType: Boolean })
	patientScheduled!: boolean | null;

	@GandalfProperty({ designType: ProviderResponse })
	provider!: ProviderResponse | null;

	@GandalfProperty({ designType: RecurringDefinitionResponse })
	recurringDefinition!: RecurringDefinitionResponse | null;

	@GandalfProperty({ designType: Number })
	relatedAppointmentId!: number | null;

	@GandalfProperty({ designType: SecurityRoleResponse })
	role!: SecurityRoleResponse | null;

	@GandalfProperty({ designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.ScheduleItemStatus)
	@GandalfProperty({ designType: constants.ScheduleItemStatus })
	status!: constants.ScheduleItemStatus | null;

	@GandalfProperty({ designType: String })
	subType!: string | null;

	@GandalfProperty({ designType: Number })
	subTypeId!: number | null;

	@GandalfProperty({ designType: String })
	summary!: string | null;

	@GandalfProperty({ designType: EncounterTemplateResponse })
	template!: EncounterTemplateResponse | null;

	@GandalfConstantDecorator(constants.ScheduleItemType)
	@GandalfProperty({ designType: constants.ScheduleItemType })
	type!: constants.ScheduleItemType | null;

	@GandalfProperty({ designType: Date })
	updatedOn!: Date | null;

}
